<template>
  <div class="rightbox">
    <Hot1 v-if="hot1.length>0" :list="hot1" />
    <Hot2 v-if="hot2.length>0" :list="hot2" />
    <Hot3 v-if="hot3.length>0" :list="hot3" />
    <Hot4 v-if="hot4.length>0" :list="hot4" />
  </div>
</template>
<script>
import Hot1 from '@/components/commonRightList/hot1/index.vue'
import Hot2 from '@/components/commonRightList/hot2/index.vue'
import Hot3 from '@/components/commonRightList/hot3/index.vue'
import Hot4 from '@/components/commonRightList/hot4/index.vue'
import { getRightData } from '@/api/api.js'
import { formatTime } from '@/utils/timeFormat'
export default {
  components: { Hot1, Hot2, Hot3, Hot4 },
  data() {
    return {
      randomimg: Math.floor(Math.random() * 5),
      banner: require('@/static/banner_img3.jpg'),
      hot1: [],
      hot2: [],
      hot3: [],
      hot4: []
    }
  },
  mounted() {
    getRightData().then(res => {
      this.hot1 = res.data.hotContent
      this.hot2 = res.data.latestVideo
      this.hot3 = res.data.latestNews
      this.hot4 = res.data.latestSpeak
      for (let i = 0; i < this.hot4.length; i++) {
        this.hot4[i].CREATE_DATE = formatTime(this.hot4[i].CREATE_DATE)
      }
    })
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>

</style>
